import "./NotFound.css";
const NotFound = () => {
  return (
    <div class="oops-page">
          <div class="overlay">
      <p class="oops-text">Oops!</p>
      <br/>
    <p class="notfound-title">404 – Page introuvable</p> 
    <p class="notfound-content">La page que vous recherchez n’existe pas ou a été déplacée.</p> 
    </div></div>
  );
};

export default NotFound;
